export default class Sys {
    /**
     * 操作系统位数
     * @returns {string}
     */
    static getEdition() {
        let userAgent = navigator.userAgent.toLocaleLowerCase()
        if (userAgent.indexOf("64") > -1) {
            return '64位'
        } else {
            return '32位'
        }
    }

    /**
     * 操作系统名称
     * @returns {string|*}
     */
    static getSysName() {
        let userAgent = navigator.userAgent.toLocaleLowerCase() //toLocaleLowerCase()将字母转小写
        let wins = [
            {
                sys: 'windows nt 5.0',
                alias: 'windows 2000',
                name: 'Win2000'
            },
            {
                sys: 'windows nt 5.1',
                alias: 'windows xp',
                name: 'WinXP'
            },
            {
                sys: 'windows nt 5.2',
                alias: 'windows 2003',
                name: 'Win2003'
            },
            {
                sys: 'windows nt 6.0',
                alias: 'Windows Vista',
                name: 'WinVista'
            },
            {
                sys: 'windows nt 6.1',
                alias: 'Windows 7',
                name: 'Win7'
            },
            {
                sys: 'windows nt 6.2',
                alias: 'Windows 8',
                name: 'Win8'
            },
            {
                sys: 'windows nt 10.0',
                alias: 'Windows 10',
                name: 'Win10'
            },
            {
                sys: 'mac',
                alias: 'macos',
                name: 'MacOS'
            }
        ]
        console.log(userAgent)
        for (let win of wins) {
            if (userAgent.indexOf(win.sys) > -1 || userAgent.indexOf(win.alias) > -1) {
                return win.name
            }
        }
    }

    /**
     * 获取浏览器信息
     * @returns {string}
     */
    static getBrowser() {
        let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串


        let isIE11 = userAgent.toLowerCase().match(/rv:([\d.]+)\) like gecko/); // IE 11中userAgent已经不包含'msie'所以用'msie'不能判断IE 11
        let isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
        let isIE = (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) || isIE11; //判断是否IE浏览器
        let isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
        let isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
        let isSafari = userAgent.indexOf("Safari") > -1
            && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
        let isChrome = userAgent.indexOf("Chrome") > -1
            && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器

        if (isIE) {
            let reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            let fIEVersion = parseFloat(RegExp["$1"])
            if (fIEVersion == 7) {
                return "IE7";
            } else if (fIEVersion == 8) {
                return "IE8";
            } else if (fIEVersion == 9) {
                return "IE9";
            } else if (fIEVersion == 10) {
                return "IE10";
            } else if (isIE11) { // IE 11中userAgent已经不包含'msie'所以用'msie'不能判断IE 11
                return "IE11";
            } else {
                return "IE";
            }//IE版本过低
        }
        if (isOpera) {
            return "Opera";
        }
        if (isEdge) {
            return "Edge";
        }
        if (isFF) {
            return "Firefox";
        }
        if (isSafari) {
            return "Safari";
        }
        if (isChrome) {
            return "Chrome";
        }
        return '--'
    }

    static waitFor(func, limit) {
        if (func()) {
            return
        } else {
            var start = new Date().getTime();
            console.log("waitFor ")
            while (new Date().getTime() < start + 1000) ;
            limit--
            if (limit > 0) {
                this.waitFor(func, limit)
            }
        }
    }
}